import React from 'react'
import { Link } from 'react-router-dom'
import Meta from '../components/Meta'
import {BiArrowBack} from 'react-icons/bi'
import watch from '../images/watch.jpg'
import Container from '../components/Container'

const CheckOut = () => {
  return (
    <>
        <Meta title='CheckOut'/>
        <Container class1="checkout-wrapper home-wrapper-2 py-5">
            <div className="row">
                <div className="col-7">
                    <div className="checkout-left-data">
                        <h3 className="website-name">
                            Rahmat Store
                        </h3>
                        <nav style={{"--bs-breadcrumb-divider":">"}}>
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/cart" className='text-dark total-price'>Cart</Link>
                                </li>
                                &nbsp;/
                                <li className="breadcrumb-item total-price active">
                                    Information
                                </li>
                                &nbsp;/
                                <li className="breadcrumb-item total-price">
                                    Shipping
                                </li>
                                &nbsp;/
                                <li className="breadcrumb-item total-price">
                                    Payment
                                </li>
                            </ol>
                        </nav>
                        <h4 className="title total-price">Contact Information</h4>
                        <p className="user-details total">Rahmat (fayeq.rahmat@gmail.com)</p>
                        <h4 className='mb-3'>Shipping Address</h4>
                        <form action="" className='d-flex flex-wrap justify-content-between gap-15'>
                            <div className='flex-grow-1'>
                                <input type="text" className="form-control" placeholder='First Name' />
                            </div>
                            <div className='flex-grow-1'>
                                <input type="text" className="form-control" placeholder='Last Name' />
                            </div>
                            <div className='w-100'>
                                <input type="text" className="form-control" placeholder='Address' />
                            </div>
                            <div className='w-100'>
                                <input type="text" className="form-control" placeholder='Apartment, Suite, etc' />
                            </div>
                            <div className='w-100'>
                                <select name="" id="" className="form-control form-select">
                                    <option selected disabled>-- select country --</option>
                                    <option value="">US</option>
                                    <option value="">UK</option>
                                </select>
                            </div>
                            <div className='flex-grow-1'>
                                <select name="" id="" className="form-control form-select">
                                    <option selected disabled>-- select state --</option>
                                    <option value="">US</option>
                                    <option value="">UK</option>
                                </select>
                            </div>
                            <div className='flex-grow-1'>
                                <input type="text" className="form-control" placeholder='City' />
                            </div>
                            
                            <div className='flex-grow-1'>
                                <input type="text" className="form-control" placeholder='Zip Code'/>
                            </div>
                            <div className="w-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <Link to='/cart' className='text-dark'> <BiArrowBack className='me-1' /> Return to Cart</Link>
                                    <Link to='#' className='button'>Continue to Shipping</Link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="col-5">
                    <div className='border-bottom py-4'>
                        <div className="d-flex align-items-center gap-10 mb-2">
                            <div className='w-75 d-flex gap-10'>
                                <div className='w-25 position-relative'>
                                    <span style={{top:'-20px',right:'2px'}} className="badge bg-secondary text-white rounded-circle p-2 position-absolute">
                                        2
                                    </span>
                                    <img src={watch} className="img-fluid rounded" alt="product" />
                                </div>
                                <div>
                                    <h5 className="title total-price">watch</h5>
                                    <p className='total-price'>s / #lorem</p>
                                </div>
                            </div>
                            <div className='flex-grow-1'><h5 className='total'>$100</h5></div>
                        </div>
                    </div>   
                    <div className='border-bottom py-4'>
                        <div className='d-flex justify-content-between align-items-center'>
                            <p className='total'>Sub Toal</p>
                            <p className='total-price'>$490</p>
                        </div>    
                        <div className='d-flex justify-content-between align-items-center'>
                            <p className='border-0 total'>Shiping</p>
                            <p className='total-price'>$10</p>
                        </div>
                    </div>
                    <div className='d-flex justify-content-between align-items-center border-bottom py-4'>
                        <h4 className='total'>Total</h4>
                        <h5 className='total-price'>$500</h5>
                    </div>
                </div>
            </div>
        </Container>
    </>
  )
}

export default CheckOut